export default __webpack_public_path__ + "static/media/Unit.ed4e725c.xlsx";